import pdfMake, { userMark, setMyConfig, makeTableContent } from "../utils/pdf";

export default function(pContent) {
  const columns = [
    "agencia:w*",
    "file:wauto",
    "nombre:w*",
    {
      key: "nroAdultos",
      label: "PAX",
      width: "auto",
    },
    {
      key: "nroNinos",
      label: "CHD",
      width: "auto",
    },
    "hotel:w*",
    {
      key: "servicioTipo",
      label: "Tipo",
      width: "auto",
    },
    {
      key: "moneda",
      label: "Moneda",
      width: "auto",
    },
    {
      key: "tarifa",
      label: "Monto",
      width: 50,
    },
    "observaciones:w*",
  ];

  const table = makeTableContent([...pContent.items], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Liquidación de Orden de Servicio` + (pContent.preview ? " (Previsualización)" : ""),
      },
      content: [
        {
          text: "Liquidación de Orden de Servicio" + (pContent.preview ? " (Previsualización)" : ""),
          style: "h1",
        },
        {
          columns: [
            {
              text: `Servicio: ${pContent.header.servicio}`,
              width: "auto",
            },
            {
              text: `Fecha: ${pContent.header.fecha}`,
              width: "auto",
            },
            {
              text: `Código: ${pContent.header.codigo}`,
              width: "auto",
            },
            {
              text: `Idioma: ${pContent.header.idioma}`,
              width: "auto",
            },
            ...(pContent.preview == false
              ? [
                  {
                    text: `Fecha Liquidación: ${pContent.header.fechaLiquidacion}`,
                    width: "auto",
                  },
                ]
              : []),
          ],
          margin: [0, 0, 0, 5],
        },
        table,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}
